import Relay from 'react-relay';
/**
*  New lightGroup mutation
*/
export default class NewLightGroupMutation extends Relay.Mutation {
  /**
  *  Mutation
  */
  getMutation() {
    return Relay.QL`mutation Mutation{
      newLightGroup
    }`;
  }
  /**
  *  Variables
  */
  getVariables() {
    return {
      lightGroup: {
        ...this.props.lightGroup
      }
    };
  }
  /**
  *  Fat query
  */
  getFatQuery() {
    return Relay.QL`
      fragment on newLightGroupPayload @relay(pattern: true){
        clientMutationId,
        viewer{
            id
        }
        lightGroup {
            id, 
            name,
            description, 
            status,
            accessMinutes {
                before,
                after
            }
            allowUserAccess
            infrastructures {
                id
            }
            externalId
        }
      }
    `;
  }

  /**
  *  Config
  */
  getConfigs() {
    return [{
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          viewer: this.props.viewer.id,
        },
    }];
  }

  static fragments = {
    viewer: () => Relay.QL`
      fragment on Viewer {
          id
      }
    `,
  };
}



// WEBPACK FOOTER //
// ./src/mutations/Venue/NewLightGroupMutation.js